module.exports = __webpack_public_path__ + "static/img/dy2-4.f70d8e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dy2-4.png
// module id = 956
// module chunks = 0